import { DownloadIcon, PlusIcon } from "lucide-react";
import { CertKpiSection } from "../components/cert-kpi-section.js";
import { PortalShell } from "../components/portal-shell.js";
import { RecentCertsTable } from "../components/recent-certs-table.js";

export function AdminDashboardPage() {
	return (
		<PortalShell activeId="overview" pageTitle="Overview">
			<div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
				{/* Page header */}
				<div className="mb-8 flex items-end justify-between gap-6 border-b border-border pb-6">
					<div>
						<div className="mb-2 flex items-center gap-2.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">
							<span className="inline-block h-1.5 w-1.5 rounded-full bg-green-500 shadow-[0_0_0_4px_rgba(127,184,122,0.25)]" />
							Live · Q1 2026 · All programs
						</div>
						<h1 className="text-[28px] font-semibold leading-tight tracking-[-0.025em] text-foreground">
							Good morning, Elena
						</h1>
					</div>
					<div className="flex flex-shrink-0 items-center gap-2">
						<button
							type="button"
							className="flex h-9 items-center gap-2 rounded-[10px] border border-border bg-card px-4 text-[13px] font-medium text-foreground transition-colors hover:bg-muted/60"
						>
							<DownloadIcon className="h-[15px] w-[15px]" />
							Export
						</button>
						<button
							type="button"
							className="flex h-9 items-center gap-2 rounded-[10px] px-4 text-[13px] font-semibold transition-all hover:brightness-95"
							style={{
								background: "var(--color-secondary)",
								color: "var(--color-secondary-foreground)",
								border: "1px solid var(--color-secondary)",
							}}
						>
							<PlusIcon className="h-[15px] w-[15px]" />
							New certificate
						</button>
					</div>
				</div>

				{/* KPI row */}
				<CertKpiSection />

				{/* Latest certificates */}
				<div className="overflow-hidden rounded-[14px] border border-border bg-card">
					<div className="flex items-center justify-between gap-4 border-b border-border/60 px-6 py-5">
						<div>
							<div className="text-[14px] font-semibold text-foreground">
								Latest certificates
							</div>
							<div className="mt-0.5 text-[12px] text-muted-foreground">
								Sorted by last update · 18 waiting for approval
							</div>
						</div>
						<button
							type="button"
							className="flex h-8 items-center rounded-[10px] border border-border bg-card px-3 text-[12px] font-medium text-foreground transition-colors hover:bg-muted/60"
						>
							View all
						</button>
					</div>
					<RecentCertsTable />
				</div>
			</div>
		</PortalShell>
	);
}
